import type { StudentResource } from '@backend/resources/student/types'
import type { GetStudentResponse } from '@backend/students-api/routes/students/GET/types'

import { ApiStudentRequest, request } from '../utils'

import { useAuthQuery } from './auth'

export type Student = StudentResource

export function useGetStudent() {
  const { isLoading, data } = useAuthQuery(
    ['students'],
    async () => {
      return request<GetStudentResponse>(
        new ApiStudentRequest('/students', {
          method: 'GET',
        }),
        {
          isExpectedResponse: (res): res is GetStudentResponse => res,
        },
      )
    },
    {
      refetchOnMount: true,
    },
  )

  return {
    isLoadingStudent: isLoading,
    student: data?.data,
  }
}
